import React, { Component, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import JobInfo from "./JobInfo";

import accounting from "accounting";
import ArrowLeft from "@material-ui/icons/ArrowLeft";

const salesTaxRate = 0.0675;

const styles = (theme) => ({
  dueTodayListItemTextPrimary: {
    fontSize: "2rem",
    fontWeight: "500",
  },
  dueTodayPrice: {
    color: theme.palette.secondary.main,
  },
  icon: {
    fontSize: "3.75rem",
  },
  goback: {
    marginTop: "10px",
  },
  gobackIcon: {
    fontSize: "2rem",
    marginBottom: "-10px",
  },
});

const Confirmed = (props) => {
  const { classes } = props;

  useEffect(() => {
    // localStorage.clear();
  }, []);

  const subtotalBoxesPrice = Object.keys(props.boxesFormValues).reduce(
    (total, boxKey) => {
      const boxQuantity = props.boxesFormValues[boxKey];

      if (boxQuantity) {
        const boxPrice = props.boxes.find(
          (box) => "box" + box.id === boxKey
        ).price;
        const totalBoxPrice = boxQuantity * boxPrice;

        return totalBoxPrice + total;
      } else {
        return total; //Return total
      }
    },
    0
  );
  const boxesSalesTaxAmount = subtotalBoxesPrice * salesTaxRate;
  const totalBoxesPrice = subtotalBoxesPrice + boxesSalesTaxAmount;

  return (
    <Grid container spacing={4} justify="center" className={classes.root}>
      <Grid item xs={10} md={5}>
        <CheckCircleIcon className={classes.icon} color="secondary" />
        <Typography gutterBottom={true} variant="h4" component="h4">
          Reservation Confirmed
        </Typography>
        <Typography color="textSecondary">
          Your reservation and payment method have been confirmed. You will
          recieve an email with your reservation details.
        </Typography>
        <Typography color="textSecondary" className={classes.goback}>
          <ArrowLeft color="secondary" className={classes.gobackIcon} />
          <a
            href="https://www.gomovingbuddy.com/"
            onClick={() => {
              localStorage.clear();
            }}
          >
            Go back to the home page
          </a>
        </Typography>
      </Grid>
      <Grid item xs={10} md={5}>
        <Card>
          <CardContent>
            <JobInfo
              quote={props.quote}
              originDestinationFormValues={props.originDestinationFormValues}
              locationsFormValues={{ ...props.locationsFormValues }}
              boxesFormValues={props.boxesFormValues}
              boxes={props.boxes}
              scheduleFormValues={props.scheduleFormValues}
            ></JobInfo>
            <Divider />

            <List>
              <ListItem>
                <ListItemText
                  className={classes.estimateListItemText}
                  primaryTypographyProps={{
                    className: classes.dueTodayListItemTextPrimary,
                  }}
                  primary={
                    <span>
                      Paid today:{" "}
                      <span className={classes.dueTodayPrice}>
                        {accounting.formatMoney(totalBoxesPrice)}
                      </span>
                    </span>
                  }
                />
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

Confirmed.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  quote: PropTypes.object.isRequired,
  originDestinationFormValues: PropTypes.object.isRequired,
  boxesFormValues: PropTypes.object, //May not exist if they skipped boxes
  boxes: PropTypes.array, //May not exist if they skipped boxes
  locationsFormValues: PropTypes.object.isRequired,
  scheduleFormValues: PropTypes.array.isRequired,
};

export default withStyles(styles)(Confirmed);
